import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
    showPitches: {
        id: "tasks.solfaName.showPitches",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
});

export default messages;
